<app-loader [showLoader]="isLoading"></app-loader>

<div class="row">
  <div class="col-6 col-sm-6">
    <h3 class="text-left">Auctions</h3>
  </div>
  <div class="col-12 col-sm-6 text-right" *ngIf="checkCreateAuction()">
    <a role="button" class="btn btn-colored text-right" routerLink="add">
      + Create New Auction
    </a>
  </div>
</div>

<div class="row mt-3">
  <ng-container *ngIf="auctionStatusType != []">
    <div class="col-12">
      <div class="list-filter-tabs">
        <button type="button" class="list-tab" *ngFor="let type of auctionStatusType" role="button"
          (click)="setQueryParam(type.text.toLowerCase(), type.value)" [ngClass]="{
            active: type.text.toLowerCase() == selectedFilter.toLowerCase()
          }">
          {{ type.text | uppercase }}
        </button>
      </div>
    </div>
  </ng-container>
</div>

<section class="table-search-wrap mb-2 mt-4 pb-2">
  <div class="d-none d-md-block">
    <div class="row for-desktop-filters">
      <div class="col-12 col-md-8">
        <div class="row">
          <div class="col-6 pr-0">
            <search-control [placeholder]="'Auction Title or Tagline or Sale Code'" (value)="changeSearchValue($event)">
            </search-control>
          </div>

          <div class="col-6 pr-0">
            <filter-control [title]="'Filter by sale Type'" [control]="saleTypeId" [filters]="saleType"
              (currentValue)="onSaleTypeFilter($event)"></filter-control>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="for-mobile-filters d-block d-md-none">
    <div class="row mobile-filters-wrap" [class.activeFilter]="classToggled">
      <div class="for-search">
        <div class="form-group m-0">
          <search-control [placeholder]="'Auction Title or Tagline or Sale Code'" (value)="changeSearchValue($event)"
            [mobileFilter]="true" (toogleButton)="classToggled = $event">
          </search-control>
        </div>

        <span class="mobile-filter ml-2" role="button" (click)="mobileFilters = true" [ngClass]="{
            'badge-active': saleTypeId != null
          }">
          <img src="../assets/images/mobile-filter.svg" title="mobile-filter-icon" alt="mobile-filter-icon" />
        </span>
      </div>
    </div>
  </div>
</section>

<section class="filter-box-wrap" *ngIf="mobileFilters">
  <div class="filter-box-inner">
    <div class="top-wrap">
      <h3 class="filter-name">Filter By:</h3>

      <span class="cross-icon" role="button" (click)="mobileFilters = false">
        <img src="../assets/images/cross.svg" title="filter-cross-icon" alt="filter-cross-icon" />
      </span>
    </div>
    <div class="list-wrap">
      <div class="list-parts">
        <h3 class="parts-outer-name">Sale Type</h3>

        <div class="custom-checks-outer">
          <div class="custom-checks">
            <input id="check100" type="radio" name="register" [value]="null" role="button"
              (click)="onSaleTypeFilter(null)" />
            <label for="check100">All</label>
          </div>
          <div class="custom-checks" *ngFor="let item of saleType; let i = index">
            <input [id]="'check' + i" type="radio" name="register" [value]="item.value" role="button"
              (click)="onSaleTypeFilter(item.value)" />
            <label [for]="'check' + i">{{ item.text }}</label>
          </div>
        </div>
      </div>

      <div class="filter-btn-wrap pt-2">
        <button class="btn btn-colored w-100" type="button" role="button" (click)="mobileFilters = false">
          Apply Filters
        </button>
      </div>
    </div>
  </div>
</section>

<app-paginator [paginationId]="'server'" [currentPage]="pageNumber" [pageSize]="pageSize" (page)="onPageChange($event)"
  *ngIf="showView">
</app-paginator>

<div class="empty-state-container empty-pad" *ngIf="totalAuctions == 0; else showTable">
  <div class="empty-state-content">
    <ng-container *ngIf="auctionMode == 'pending'">
      <img alt="empty-state" src="../../../../assets/images/auction-success.svg" />
    </ng-container>
    <ng-container *ngIf="auctionMode != 'pending'">
      <img alt="empty-state" src="../../../../assets/images/empty-state-icon.svg" />
    </ng-container>

    <h3 class="_heading">
      There are no {{ auctionMode | titlecase }} Auctions yet
    </h3>
    <p class="_text" *ngIf="role != roles.auctionAdmin">
      To create a new Auction use the button below
    </p>
    <button class="btn btn-colored" type="button" [routerLink]="['../add']" *ngIf="role != roles.auctionAdmin">
      + Create New Auction
    </button>
  </div>
</div>

<ng-template #showTable>
  <div class="card-row" *ngFor="
      let list of auctionList
        | paginate
          : {
              id: 'server',
              itemsPerPage: pageSize,
              currentPage: pageNumber,
              totalItems: totalAuctions
            }
    ">
    <div class="row">
      <div class="col-auto max-width--200 card-title-left">
        <p class="card-heading for-attr-hdg" data-column="Auction Title">
          <span>{{ list.title }}</span>
        </p>
        <p class="card-description no-card" [innerHTML]="list.tagline | sanitizedHtml"></p>
        <div class="no-card">
          <p class="card-loc-info mr-3" *ngFor="let loc of list.locations">
            <img alt="location-icon" src="../assets/images/location-green.svg" />
            <span class="ml-2">{{ loc.name }}</span>
          </p>
        </div>
        <span class="card-badge no-card min-width-auto">
          {{ list.saleTypeName }}
        </span>
      </div>
      <div class="col-auto ml-md-auto card-title-right">
        <div class="for-icons">
          <span *ngIf="checkApproveAuction()">
            <button class="btn btn-colored mr-2" *ngIf="
                list?.isSentForApproval == true &&
                auctionMode == 'pending' &&
                (role == roles.admin || role == roles.auctionAdmin)
              " role="button" (click)="openApproveAuction(templateApprove, list)">
              Approve
            </button>
          </span>

          <ng-container *ngIf="list.saleType.isDetailPageInHouse">
            <ng-container *ngIf="!list.saleType.isCatalogReadOnly">
              <span *ngIf="['live'].includes(auctionMode)">
                <button type="button" [routerLink]="[list.id, 'bids']" class="btn btn-colored mr-2">
                  View Bids
                </button>
              </span>
              <span *ngIf="['archived', 'recent'].includes(auctionMode)">
                <button type="button" [routerLink]="[list.id, 'result']" class="btn btn-colored mr-2"
                  *ngIf="list.saleType.isCatalogReadOnly">
                  View Results
                </button>
                <button type="button" [routerLink]="[list.id, 'bids']" class="btn btn-colored mr-2"
                  *ngIf="!list.saleType.isCatalogReadOnly">
                  View Bids
                </button>
              </span>
            </ng-container>
          </ng-container>

          <a class="hover-icon view-auction-icon mr-2 custom-tooltip custom-tooltip2" #tooltip="matTooltip"
            matTooltip="View Auction" matTooltipClass="custom-tooltip-icon" [matTooltipPosition]="'above'"
            [routerLink]="[list.id]"></a>

          <a class="hover-icon edit-icon mr-2 custom-tooltip custom-tooltip2" #tooltip="matTooltip"
            matTooltip="Edit Auction Details" matTooltipClass="custom-tooltip-icon" [matTooltipPosition]="'above'"
            [routerLink]="[list.id, 'edit']" *ngIf="auctionMode !== 'archived'"></a>

          <a *ngIf="auctionMode == 'pending'" role="button" (click)="openDeleteAuction(template, list)"
            class="hover-icon delete-icon mr-2 custom-tooltip custom-tooltip2" #tooltip="matTooltip" matTooltip="Delete"
            matTooltipClass="custom-tooltip-icon" [matTooltipPosition]="'above'"></a>

          <ng-container *ngIf="list.saleType.isDetailPageInHouse">
            <ng-container *ngIf="list.saleType.isCatalogUploadAllowed">
              <a *ngIf="!['recent', 'archived'].includes(auctionMode)"
                class="hover-icon configure-icon mr-2 custom-tooltip custom-tooltip2" #tooltip="matTooltip"
                matTooltip="Configure Lot Catalog" [routerLink]="[list.id, 'configure-lot']"
                [queryParams]="{ returnTo: currentUrl }" matTooltipClass="custom-tooltip-icon"
                [matTooltipPosition]="'above'"></a>
            </ng-container>
            <ng-container *ngIf="
                list.saleType.registrationFormat ===
                  registrationFormat.tbgRegistration &&
                !list.saleType.isCatalogReadOnly
              ">
              <a *ngIf="auctionMode !== 'pending'" class="hover-icon register-icon mr-2 custom-tooltip custom-tooltip2"
                #tooltip="matTooltip" role="button" (click)="goToUsers(list.id)" matTooltip="Registered Users"
                matTooltipClass="custom-tooltip-icon" [matTooltipPosition]="'above'"></a>
            </ng-container>
          </ng-container>

          <div class="custom-dropdown" *ngIf="auctionMode != 'pending'">
            <button class="no-bg-btn hover-icon" mat-icon-button
              [matMenuTriggerFor]="listingMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #listingMenu="matMenu">
              <div class="custom-dropdown">
                <button mat-menu-item *ngIf="
                    (auctionMode == 'upcoming' ||
                      auctionMode == 'live' ||
                      auctionMode == 'recent' ||
                      auctionMode == 'archived') &&
                    list.isActive
                  " role="button" (click)="openDeActivateAuction(template2, list, true)">
                  <span>Deactivate Auction</span>
                </button>

                <ng-container *ngIf="list.saleType.isDetailPageInHouse">
                  <ng-container *ngIf="
                      list.saleType.registrationFormat ===
                        registrationFormat.tbgRegistration &&
                      list.saleType.isCatalogUploadAllowed &&
                      !list.saleType.isCatalogReadOnly
                    ">
                    <button mat-menu-item *ngIf="
                        !['recent', 'archived'].includes(auctionMode) &&
                        list.isRegistrationActive == false &&
                        (role == roles.auctionAdmin ||
                          role == roles.admin ||
                          role == roles.customerService)
                      " role="button" (click)="openStatusAuction(startStopTemplate, list.id, 1)">
                      <span>Start Registration</span>
                    </button>
                    <button mat-menu-item *ngIf="
                        !['recent', 'archived'].includes(auctionMode) &&
                        list.isRegistrationActive == true &&
                        (role == roles.auctionAdmin ||
                          role == roles.admin ||
                          role == roles.customerService)
                      " role="button" (click)="openStatusAuction(startStopTemplate, list.id, 0)">
                      <span>Stop Registration</span>
                    </button>
                    <button mat-menu-item *ngIf="
                        !['recent', 'archived'].includes(auctionMode) &&
                        list.isEligibleForCommonRegistration == true &&
                        list.isRegistrationSyncEnabled == false &&
                        list.commonRegistrationEnd == null
                      " role="button" (click)="openApproveAuction(templateCommon, list.id)">
                      <span>Start Common Registration</span>
                    </button>
                    <button mat-menu-item *ngIf="
                        !['recent', 'archived'].includes(auctionMode) &&
                        list.isRegistrationSyncEnabled == true &&
                        list.commonRegistrationEnd == null
                      " role="button" (click)="stopSyncRegistrationWithOtherAuction(list.id)">
                      <span>Stop Common Registration</span>
                    </button>
                    <button mat-menu-item *ngIf="!['recent', 'archived'].includes(auctionMode)" role="button"
                      (click)="goToBidders(list.id)">
                      <span>View Bidders</span>
                    </button>

                  </ng-container>

                  <!-- this is for lot management no matter bidding is happening or not -->
                  <ng-container *ngIf="list.saleType.isCatalogUploadAllowed">
                    <button mat-menu-item [routerLink]="[list.id, 'configure-lot']"
                      [queryParams]="{ returnTo: currentUrl, stepActive: 3 }"
                      *ngIf="!['recent', 'archived'].includes(auctionMode)">
                      <span>Manage Lots</span>
                    </button>
                    <button mat-menu-item *ngIf="
                        (auctionMode == 'upcoming' ||
                          auctionMode == 'recent' ||
                          auctionMode == 'archived') &&
                        list.isLotsPublished
                      " role="button" (click)="openDeleteAuction(unpublishTemplate, list)">
                      <span>Unpublish Lot Catalog</span>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="auctionMode == 'archived'">
                    <button mat-menu-item role="button" (click)="openUnarchiveModal(unArchiveTemplate, list)">
                      <span>Unarchive Auction</span>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="auctionMode == 'recent'">
                    <button mat-menu-item role="button" (click)="openUnarchiveModal(unArchiveTemplate, list)">
                      <span>Archive Auction</span>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="auctionMode == 'recent' || auctionMode == 'archived'">
                    <button mat-menu-item role="button" (click)="openUnarchiveModal(featuredPastTemplate, list)">
                      <span>Change Featured Past</span>
                    </button>
                  </ng-container>
                </ng-container>

                <button mat-menu-item *ngIf="!list.isPublic" role="button" (click)="markItFeatured(list.id)">
                  <span>Make Featured Auction</span>
                </button>
                <button mat-menu-item role="button" (click)="goToReportSection(list.id, auctionMode)">
                  <span>Reports</span>
                </button>
                <button mat-menu-item *ngIf="
                    !['recent', 'archived'].includes(auctionMode) &&
                    list.saleType.canMarkOfferingAsSold == true
                  " role="button" (click)="markAsSold(list.id)">
                  <span>Mark auction as Sold</span>
                </button>

                <button mat-menu-item *ngIf="
                    list.isPublic &&
                    (auctionMode == 'upcoming' || auctionMode == 'live')
                  " role="button" (click)="markItFeatured(list.id)">
                  <span>Remove From Featured Auctions</span>
                </button>

                <ng-container *ngIf="
                    list.saleType.registrationFormat ===
                      registrationFormat.thirdPartyRegistration &&
                    list.saleType.isCatalogUploadAllowed &&
                    list.saleType.isCatalogReadOnly
                  ">
                  <button mat-menu-item *ngIf="auctionMode == 'recent' || auctionMode == 'archived'" role="button"
                    (click)="importAuctionUserModal(importModal, list)">
                    <span>Import Auction Results</span>
                  </button>
                  <button mat-menu-item *ngIf="auctionMode == 'recent' || auctionMode == 'archived'"
                    [routerLink]="[list.id, 'result']">
                    <span>View Auction Results</span>
                  </button>
                  <button mat-menu-item *ngIf="auctionMode == 'recent' || auctionMode == 'archived'"
                    [routerLink]="[list.id, 'imported-users']">
                    <span>View Registered Users</span>
                  </button>
                </ng-container>
              </div>
            </mat-menu>
          </div>

          <ng-container *ngIf="
              list.saleType.isDetailPageInHouse &&
              list.saleType.isCatalogUploadAllowed
            ">
            <div class="custom-dropdown" *ngIf="auctionMode == 'pending'">
              <button class="no-bg-btn hover-icon" mat-icon-button [matMenuTriggerFor]="listingMenu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #listingMenu="matMenu">
                <div class="custom-dropdown">
                  <button mat-menu-item [routerLink]="[list.id, 'configure-lot']"
                    [queryParams]="{ returnTo: currentUrl, stepActive: 3 }"
                    *ngIf="list.saleType.isCatalogUploadAllowed">
                    <span>Manage Lots</span>
                  </button>
                  <button mat-menu-item role="button" (click)="goToReportSection(list.id, auctionMode)">
                    <span>Reports</span>
                  </button>
                </div>
              </mat-menu>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="row no-card">
      <div class="col-6 col-sm-auto mt-3">
        <p class="card-info-h">
          <img alt="user" src="../assets/images/user-green.svg" />
          <span>Sale Manager</span>
        </p>
        <p class="card-info-d">{{ list.saleManagerName }}</p>
      </div>
      <ng-container *ngIf="list?.saleType?.isDetailPageInHouse">
        <div class="col-6 col-sm-auto mt-3">
          <p class="card-info-h">
            <img alt="link-icon" src="../assets/images/link.svg" />
            <span>Public Link</span>
          </p>
          <p class="card-info-d"><a (click)="openLink(websiteUrl+list?.auctionCode)" style="cursor: pointer; color: #8d1231;
            text-decoration: underline;
            cursor: pointer;">Click to view auction detail</a></p>

          <p class="card-info-d"><a (click)="openLotsLink(websiteUrl + list?.auctionCode + '/lots')" style="cursor: pointer; color: #8d1231;
  text-decoration: underline;
  cursor: pointer;">Click to view lot catalog</a></p>
        </div>
      </ng-container>
      <div class="col-6 col-sm-auto mt-3" *ngIf="auctionMode == 'live' || auctionMode == 'upcoming'">
        <p class="card-info-h">
          <img alt="registration-icon" src="../assets/images/registrations-grey.svg" />
          <span>Registrations</span>
        </p>
        <p class="card-info-d" *ngIf="list !== undefined && list.isRegistrationActive == true">
          Enabled
        </p>
        <p class="card-info-d" *ngIf="list !== undefined && list.isRegistrationActive == false">
          Disabled
        </p>
      </div>
      <div class="col-6 col-sm-auto mt-3" *ngIf="
          auctionMode == 'live' ||
          (auctionMode == 'upcoming' && list !== undefined && list.isPublic)
        ">
        <p class="card-info-h">
          <img alt="star-icon" src="../assets/images/star-grey.svg" />
          <span>Featured</span>
        </p>
        <p class="card-info-d" *ngIf="list !== undefined && list.isPublic == true">
          Yes
        </p>
        <p class="card-info-d" *ngIf="list !== undefined && list.isPublic == false">
          No
        </p>
      </div>
      <div class="col-6 col-sm-auto mt-3">
        <p class="card-info-h">
          <img alt="calender-icon" src="../assets/images/calender.svg" />
          <span>{{
            auctionMode == "pending" || auctionMode == "upcoming"
            ? "Starts On"
            : "Started On"
            }}</span>
        </p>
        <p class="card-info-d">
          {{ list.startDateTime | toLocalDateTime: false:list?.timeZone }}
        </p>
      </div>
      <div class="col-6 col-sm-auto mt-3" *ngIf="
          !checkLotClosing(
            list.closingStartDateTimeUtc,
            list.closingEndDateTimeUtc
          )
        ">
        <p class="card-info-h">
          <img alt="calender-icon" src="../assets/images/calender.svg" />
          <span>Ends On</span>
        </p>
        <p class="card-info-d">
          {{ list.endDateTime | toLocalDateTime: false:list?.timeZone }}
        </p>
      </div>
      <div class="col-6 col-sm-auto mt-3" *ngIf="
          checkLotClosing(
            list.closingStartDateTimeUtc,
            list.closingEndDateTimeUtc
          ) && auctionMode == 'live'
        ">
        <p class="card-info-h">
          <img alt="calender-icon" src="../assets/images/calender.svg" />
          <span>Lots Closing Now</span>
        </p>
      </div>
      <div class="col-6 col-sm-auto mt-3">
        <p class="card-info-h">
          <img alt="calender-icon" src="../assets/images/calender.svg" />
          <span>Last Updated</span>
        </p>
        <p class="card-info-d">{{ list.updateOn | toLocalDateTime: true }}</p>
      </div>
      <div class="col-6 col-sm-auto mt-3" *ngIf="auctionMode == 'live' || auctionMode == 'upcoming'">
        <p class="card-info-h">
          <img alt="calender-icon" src="../assets/images/calender.svg" />
          <span>Approved By</span>
        </p>
        <p class="card-info-d">{{ list.approvedByName }}</p>
      </div>
    </div>

    <div class="row only-small">
      <p class="for-attr-hdg m-0" [attr.data-column]="
          auctionMode == 'pending' || auctionMode == 'upcoming'
            ? 'Starts On'
            : 'Started On'
        ">
        {{ list.startDateTime | date: "short" }}
      </p>

      <p class="for-attr-hdg yellow-bg m-0" data-column="Sale Type">
        {{ list.saleTypeName }}
      </p>
    </div>
  </div>
</ng-template>

<app-paginator [paginationId]="'server'" [currentPage]="pageNumber" [pageSize]="pageSize" (page)="onPageChange($event)"
  *ngIf="showView">
</app-paginator>

<ng-template #startStopTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="modalRef.hide()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body my-activate">
    <img alt="deactivate-icon" class="act-icon" src="../assets/images/deactivate_user.svg" />
    <p class="des mb-4"></p>
    <p class="des" *ngIf="startStop == 0">
      Are you sure you want to stop registration for this Auction?
    </p>
    <p class="des" *ngIf="startStop == 1">
      Are you sure you want to start registration for this Auction?
    </p>
    <button *ngIf="startStop == 0" [disabled]="submitLoader" class="btn btn-colored" role="button"
      (click)="auctionStopRegistration(registrationId)" type="button">
      <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
      Stop
    </button>
    <button *ngIf="startStop == 1" [disabled]="submitLoader" class="btn btn-colored" role="button"
      (click)="auctionStartRegistration(registrationId)" type="button">
      <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
      Start
    </button>
  </div>
</ng-template>

<!-- delete auction -->
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="modalRef.hide()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body my-activate">
    <img class="act-icon" alt="deactivate" src="../assets/images/deactivate_user.svg" />
    <h1 class="modal-inner-hdg">Delete Auction</h1>
    <p class="des mb-4"></p>
    <p class="des">Are you sure you want to delete auction?</p>
    <button [disabled]="submitLoader" class="btn btn-colored" role="button" (click)="deleteAuction(auctionModel)"
      type="button">
      <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
      Yes, Delete
    </button>
  </div>
</ng-template>

<!-- deactivate auction -->
<ng-template #template2>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="modalRef.hide()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body my-activate" *ngIf="auctionStatus == true">
    <img alt="deactivate-icon" class="act-icon" src="../assets/images/deactivate_user.svg" />
    <h1 class="modal-inner-hdg">Deactivate Auction</h1>
    <p class="des">
      <ng-container *ngIf="auctionModel.saleType.isDetailPageInHouse">
        <ng-container *ngIf="!auctionModel.saleType.isCatalogReadOnly">
          You are de-activating an auction that may have bids in place.
          De-activating the auction will delete the existing bids and any lots
          that are sold will no longer be valid.
        </ng-container>
        Are you sure you want to de-activate this Auction?
      </ng-container>
    </p>
    <button class="btn btn-white-border mr-2" role="button" (click)="closeModal()">
      No
    </button>
    <button [disabled]="submitLoader" class="btn btn-colored" role="button" (click)="deActivateAuction(auctionModel)"
      type="button">
      <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
      Yes, Deactivate
    </button>
  </div>
</ng-template>

<ng-template #unpublishTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body my-activate">
    <h1 class="modal-inner-hdg">Unpublish Lot Catalog</h1>
    <p class="des">
      This will unpublish the lot catalog from the auction on front-end site.
      Are you sure you want to proceed with this?
    </p>
    <button class="btn btn-white-border mr-2" role="button" (click)="closeModal()">
      No
    </button>
    <button [disabled]="submitLoader" class="btn btn-colored" role="button" (click)="unpublishCatalog()" type="button">
      <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
      Yes, Unpublish
    </button>
  </div>
</ng-template>

<ng-template #templateApprove>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Approve Auction</h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="approveForm">
      <p class="sm-des">
        As soon as this auction is approved, it will start appearing on the
        <br class="d-none d-md-block" />
        front end website.
      </p>

      <ng-container *ngIf="currentSelectedAuction.saleType.isDetailPageInHouse">
        <ng-container *ngIf="!currentSelectedAuction.saleType.isCatalogReadOnly">
          <div class="form-group form-check slide-check pl-0 mb-1 pb-3"
            *ngIf="currentSelectedAuction.saleType.displaySection">
            <p class="m-0 pb-1">Enable Registration for this auction</p>
            <label class="switch-slider">
              <input type="checkbox" class="form-check-input1 slide-check-input" id="enableRegistration"
                formControlName="isRegistrationActive" checked />
              <span class="slider round"></span>
            </label>
          </div>
        </ng-container>
      </ng-container>

      <div class="form-group form-check slide-check pl-0 mb-1 pb-3">
        <p class="m-0 pb-1">
          Featured (If enabled auction will appear on homepage)
        </p>
        <label class="switch-slider">
          <input type="checkbox" class="form-check-input1 slide-check-input" id="featured" formControlName="isPublic"
            checked />
          <span class="slider round"></span>
        </label>
      </div>

      <ng-container *ngIf="currentSelectedAuction.saleType.isDetailPageInHouse">
        <ng-container *ngIf="!currentSelectedAuction.saleType.isCatalogReadOnly">
          <div class="form-group m-0 pb-1">
            <div class="mat-field-width">
              <div class="custom-select-option select-with-label input-with-tooltip">
                <mat-form-field appearance="outline">
                  <mat-label>Select Auction For Common Registration
                    (Optional)</mat-label>
                  <mat-select formControlName="registrationSyncWithAuctionId">
                    <mat-option value="0" selected>None</mat-option>
                    <mat-option *ngFor="let auction of upcomingAuctions" [value]="auction.value">
                      {{ auction.text }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <span class="custom-tooltip" #tooltip="matTooltip" matTooltip="Select an Auction to link to this sale."
                  [matTooltipPosition]="'above'">
                  <img alt="info-icon" src="../assets/images/info.svg" />
                </span>
              </div>
            </div>
            <p class="note-text">
              Please note common registration auction once selected cannot be
              changed.
            </p>
          </div>
        </ng-container>
      </ng-container>

      <div class="image-popup-wrap pt-4 mt-2 approve-auc-btns-mob">
        <button class="btn btn-white-border mr-2 approve-cancel" role="button" (click)="closeModal()">
          Cancel
        </button>
        <button [disabled]="submitLoader" type="submit" class="btn btn-colored approve-auction" role="button"
          (click)="approveAuction()">
          <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
          Approve Auction
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #templateCommon>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Start Common Registration</h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="approveCommonForm">
      <div class="form-group m-0 pb-1">
        <div class="mat-field-width">
          <div class="custom-select-option select-with-label input-with-tooltip">
            <mat-form-field appearance="outline">
              <mat-label>Select Auction For Common Registration</mat-label>
              <mat-select #selectUpcomingAuction (ngModelChange)="
                  upcomingAuctionChange(selectUpcomingAuction.value)
                " formControlName="syncWithAuctionId" *ngIf="upcomingAuctions != undefined">
                <mat-option value="0" selected>None</mat-option>
                <mat-option *ngFor="let auction of upcomingAuctions" [value]="auction.value">
                  {{ auction.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span class="custom-tooltip" #tooltip="matTooltip" matTooltip="Select an Auction to link to this sale."
              [matTooltipPosition]="'above'">
              <img alt="info-icon" src="../assets/images/info.svg" />
            </span>
          </div>
        </div>
        <p class="note-text">
          Please note common registration auction once selected cannot be
          changed.
        </p>
      </div>
      <div class="image-popup-wrap pt-4 mt-2">
        <button class="btn btn-white-border mr-2" role="button" (click)="closeModal()">
          Cancel
        </button>
        <button type="submit" class="btn btn-colored" [disabled]="
            submitLoader ||
            approveCommonForm.invalid ||
            disableCommonRegistrationButton
          " role="button" (click)="syncRegistrationWithOtherAuction()">
          <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
          Start Common Auction
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #importAuction>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Import Auction Results</h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="importResultWrap importFailed">
      <img class="topIcon" alt="icon" src="../assets/images/cancel.svg" />
      <h3 class="hdg">Import Failed</h3>
      <p class="des">
        To investigate the issues please download the log file, fix errors &
        upload again.
      </p>
      <button class="btn btn-colored importBtn">
        <img alt="icon" src="../assets/images/downloadCloud.svg" /> Download Log
        File
      </button>
    </div>

    <div class="importResultWrap importSuccess">
      <img class="topIcon" alt="icon" src="../assets/images/auction-success.svg" />
      <h3 class="hdg">Import Successful</h3>
      <p class="des">210 Users | 100 Winning Lots Imported</p>
      <button class="btn btn-colored importBtn">
        Take Me to Auctions Page
      </button>
    </div>
  </div>
</ng-template>

<ng-template #importAuctionUser>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Import Auction Results</h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="importAuctionUserHeader">
      <div class="row">
        <div class="col-md-8">
          <h3>Registered Users</h3>
          <p>Import registered users to map them with winning lots</p>
        </div>
        <div class="col-md-4 text-md-right">
          <a class="btn btn-text px-0">
            <img alt="" src="../assets/images/icDownload.svg" />
            <span>Download Template</span>
          </a>
        </div>
      </div>
    </div>

    <div class="importUpload">
      <h4>Upload File</h4>
      <div class="importUploadBtn">
        <button class="btn btn-colored" role="button" (click)="browserUser.click()">
          <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Create_New_Auction_Display_Details" transform="translate(-608.000000, -975.000000)" fill="#F7F7F7">
                <g id="Group-4" transform="translate(607.000000, 974.000000)">
                  <path
                    d="M16.44363,10.07215 C16.737642,10.07215 16.975242,10.30609 16.975242,10.59568 L16.975242,10.59568 L16.975242,14.7847 C16.975242,15.073285 16.737642,15.309085 16.44363,15.309085 L16.44363,15.309085 L1.555992,15.309085 C1.262448,15.309085 1.024452,15.07522 1.024452,14.7847 L1.024452,14.7847 L1.024452,10.59568 C1.024452,10.30609 1.262448,10.07215 1.555992,10.07215 C1.849536,10.07215 2.08809,10.30609 2.08809,10.59568 L2.08809,10.59568 L2.08809,14.26117 L15.91209,14.26117 L15.91209,10.59568 C15.91209,10.30609 16.14969,10.07215 16.44363,10.07215 Z M8.999802,1.69066 C9.13806,1.69066 9.275364,1.74205 9.380502,1.84603 L9.380502,1.84603 L12.568896,5.508175 C12.778128,5.71432 12.778128,6.04843 12.568896,6.25465 C12.35853,6.461185 12.018798,6.461185 11.809566,6.25465 L11.809566,6.25465 L9.53136,3.637615 L9.53136,11.642665 C9.53136,11.932255 9.293346,12.166135 8.999802,12.166135 C8.706276,12.166135 8.468262,11.932255 8.468262,11.642665 L8.468262,11.642665 L8.468262,3.637615 L6.190128,6.25465 C5.980806,6.46219 5.64156,6.46219 5.432238,6.25465 C5.222916,6.049495 5.222916,5.71432 5.432238,5.508175 L5.432238,5.508175 L8.619192,1.84603 C8.72433,1.74205 8.861562,1.69066 8.999802,1.69066 Z"
                    id="Combined-shape-1226"></path>
                </g>
              </g>
            </g>
          </svg>
          Browse
        </button>

        <span class="browseFileName">
          <span class="mr-1">auction_registered_user.doc</span>
          <img alt="" src="../assets/images/cross.svg" />
        </span>
      </div>

      <div>
        <input class="btn btn-colored browse-btn d-none" type="file" text="Browse" #browserUser />
      </div>
    </div>

    <div class="importAuctionUserHeader">
      <div class="row">
        <div class="col-md-8">
          <h3>Winning Lot Data</h3>
          <p>Import data for winning lots</p>
        </div>
        <div class="col-md-4 text-md-right">
          <a class="btn btn-text px-0">
            <img alt="" src="../assets/images/icDownload.svg" />
            <span>Download Template</span>
          </a>
        </div>
      </div>
    </div>

    <div class="importUpload border-0">
      <h4>Upload File</h4>
      <div class="importUploadBtn">
        <button class="btn btn-colored" role="button" (click)="winning.click()">
          <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Create_New_Auction_Display_Details" transform="translate(-608.000000, -975.000000)" fill="#F7F7F7">
                <g id="Group-4" transform="translate(607.000000, 974.000000)">
                  <path
                    d="M16.44363,10.07215 C16.737642,10.07215 16.975242,10.30609 16.975242,10.59568 L16.975242,10.59568 L16.975242,14.7847 C16.975242,15.073285 16.737642,15.309085 16.44363,15.309085 L16.44363,15.309085 L1.555992,15.309085 C1.262448,15.309085 1.024452,15.07522 1.024452,14.7847 L1.024452,14.7847 L1.024452,10.59568 C1.024452,10.30609 1.262448,10.07215 1.555992,10.07215 C1.849536,10.07215 2.08809,10.30609 2.08809,10.59568 L2.08809,10.59568 L2.08809,14.26117 L15.91209,14.26117 L15.91209,10.59568 C15.91209,10.30609 16.14969,10.07215 16.44363,10.07215 Z M8.999802,1.69066 C9.13806,1.69066 9.275364,1.74205 9.380502,1.84603 L9.380502,1.84603 L12.568896,5.508175 C12.778128,5.71432 12.778128,6.04843 12.568896,6.25465 C12.35853,6.461185 12.018798,6.461185 11.809566,6.25465 L11.809566,6.25465 L9.53136,3.637615 L9.53136,11.642665 C9.53136,11.932255 9.293346,12.166135 8.999802,12.166135 C8.706276,12.166135 8.468262,11.932255 8.468262,11.642665 L8.468262,11.642665 L8.468262,3.637615 L6.190128,6.25465 C5.980806,6.46219 5.64156,6.46219 5.432238,6.25465 C5.222916,6.049495 5.222916,5.71432 5.432238,5.508175 L5.432238,5.508175 L8.619192,1.84603 C8.72433,1.74205 8.861562,1.69066 8.999802,1.69066 Z"
                    id="Combined-shape-1226"></path>
                </g>
              </g>
            </g>
          </svg>
          Browse
        </button>

        <span class="browseFileName">
          <span class="mr-1">winning_lot_data.doc</span>
          <img alt="" src="../assets/images/cross.svg" />
        </span>
      </div>

      <div>
        <input class="btn btn-colored browse-btn d-none" type="file" text="Browse" #winning />
      </div>
    </div>

    <div class="footerBtns">
      <button class="btn btn-white-border mr-2">Cancel</button>
      <button class="btn btn-colored">Import</button>
    </div>
  </div>
</ng-template>

<ng-template #importModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Import Auction Results</h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <app-import-result [auctionInfo]="auctionModel">
      <button class="btn btn-colored importBtn" role="button" (click)="closeModal()" takeToAuctionButton>
        Take Me to Auctions Page
      </button>
      <button class="btn btn-white-border mr-2" role="button" (click)="closeModal()" cancelButton>
        Cancel
      </button>
    </app-import-result>
  </div>
</ng-template>

<ng-template #unArchiveTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body my-activate">
    <h1 class="modal-inner-hdg">
      {{ auctionModel.isArchived ? "Unarchive" : "Archive" }} Auction
    </h1>
    <p class="des">
      This will {{ auctionModel.isArchived ? "unarchive" : "archive" }} the
      auction. Are you sure you want to proceed with this?
    </p>
    <button class="btn btn-white-border mr-2" role="button" (click)="closeModal()">
      No
    </button>
    <button [disabled]="submitLoader" class="btn btn-colored" role="button" (click)="unarchiveAuction()" type="button">
      <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
      Yes, {{ auctionModel.isArchived ? "Unarchive" : "Archive" }}
    </button>
  </div>
</ng-template>

<ng-template #featuredPastTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right p-0 m-0" aria-label="Close" role="button" (click)="closeModal()">
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body my-activate">
    <h1 class="modal-inner-hdg">
      {{ auctionModel.featuredItemHeader == 'featuredpast' ? "Remove as" : "Set as" }} Featured Past Auction
    </h1>
    <p class="des">
      This will {{ auctionModel.featuredItemHeader == 'featuredpast' ? "remove" : "set" }} the
      auction as a featured past auction. Are you sure you want to proceed with this?
    </p>
    <button class="btn btn-white-border mr-2" role="button" (click)="closeModal()">
      No
    </button>
    <button [disabled]="submitLoader" class="btn btn-colored" role="button" (click)="updateFeaturedPast()" type="button">
      <span *ngIf="submitLoader" class="spinner-border spinner-border-sm mr-1"></span>
      Yes
    </button>
  </div>
</ng-template>
